import React, { useContext } from "react";
import styled from "@emotion/styled";

import { ScreenSizeContext } from "./ScreenSizeContext";
import { SMALL_DEVICES } from "../mediaQueries";
import { Button } from './Button';

const Logo = styled.img`
  height: 30px;
  width: 30px;
  margin-right: 10px;

  ${SMALL_DEVICES} {
    width: 6vw;
    height: 6vw;
  }
`;

const GetItOnText = styled.div`
  font-weight: normal;
`;

const StoreNameText = styled.div`
  font-size: 22px;

  ${SMALL_DEVICES} {
    
  }
`;

export interface Props {
  storeName: string;

  storeLogo?: string;
  url?: string;
  isInverted?: boolean;
}

export const StoreButton: React.FC<Props> = (props) => {
  const { isSmallDevice } = useContext(ScreenSizeContext);

  return (
    <Button target="_blank" href={props.url} className={props.isInverted ? "inverted" : ""}>
      {props.storeLogo ? <Logo src={props.storeLogo} /> : null}
      <div>
        {!isSmallDevice ? <GetItOnText>Get it on</GetItOnText> : null}
        <StoreNameText>{props.storeName}</StoreNameText>
      </div>
    </Button>
  );
};
